import React, { useState } from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
} from 'reactstrap';

const testimonials = [
  {
    text: `“Donec facilisis quam ut purus rutrum lobortis. Donec vitae odio quis nisl dapibus malesuada. Nullam ac aliquet velit. Aliquam vulputate velit imperdiet dolor tempor tristique.”`,
    author: 'Maria Jones',
    position: 'CEO, Co-Founder, XYZ Inc.',
    img: 'images/person-1.png',
  },
  {
    text: `“Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.”`,
    author: 'John Doe',
    position: 'CTO, ABC Corp.',
    img: 'images/person-1.png',
  },
  {
    text: `“Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla.”`,
    author: 'Jane Smith',
    position: 'Product Manager, DEF Ltd.',
    img: 'images/person-1.png',
  },
];

function Testimonial() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === testimonials.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? testimonials.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = testimonials.map((testimonial, index) => (
    <CarouselItem
      className="testimonial-slider-wrap text-center"
      onExiting={() => setAnimating(true)}
      onExited={() => setAnimating(false)}
      key={index}
    >
      <div className="item">
        <div className="row justify-content-center">
          <div className="col-lg-8 mx-auto">
            <div className="testimonial-block text-center">
              <blockquote className="mb-5">
                <p>{testimonial.text}</p>
              </blockquote>
              <div className="author-info">
                <div className="author-pic">
                  <img
                    src={testimonial.img}
                    alt={testimonial.author}
                    className="img-fluid"
                  />
                </div>
                <h3 className="font-weight-bold">{testimonial.author}</h3>
                <span className="position d-block mb-3">{testimonial.position}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CarouselItem>
  ));

  return (
    <div className="testimonial-section"  
     data-aos="fade-right">
      <div className="container">
        <div className="row">
          <div className="col-lg-7 mx-auto text-center">
            <h2 className="section-title">Testimonials</h2>
          </div>
        </div>
        <Carousel activeIndex={activeIndex} next={next} previous={previous}>
          <CarouselIndicators
            items={testimonials}
            activeIndex={activeIndex}
            onClickHandler={goToIndex}
          />
          {slides}
          <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
          <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
        </Carousel>
      </div>
    </div>
  );
}

export default Testimonial;
